var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row wrapper border-bottom white-bg page-heading",staticStyle:{"height":"180px","background-color":"#2f4050","top":"0px","z-index":"5"}},[_c('div',{staticClass:"col-sm-12"},[_c('router-link',{attrs:{"active-class":"","to":{ name: 'acessos' }}},[_c('div',{staticClass:"Logo"},[_c('img',{attrs:{"src":"/img/logo.png","alt":"logo"}})])])],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-982d9e66","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/PageHeaderPaginaAcessos.vue
// module id = 2214
// module chunks = 0